import { Anchor as MantineAnchor } from '@mantine/core';

export const Anchor = MantineAnchor.extend({});
